import { ReactElement } from "react";

import VippsButton from "./VippsRegisterButton.svg?react";

export default function VippsRegisterButton(): ReactElement {
    return <VippsButton />;
}
